import { render } from "./LectureCalendar.vue?vue&type=template&id=3f4b5718&scoped=true"
import script from "./LectureCalendar.vue?vue&type=script&lang=js"
export * from "./LectureCalendar.vue?vue&type=script&lang=js"

import "./LectureCalendar.vue?vue&type=style&index=0&id=3f4b5718&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f4b5718"]])

export default __exports__